import { createFileRoute } from "@tanstack/react-router";

import { ShareLanding, shareLandingHead } from "../components/ShareLanding";
import { documentHeaders } from "../lib/seo";

/**
 * `/p/<code>` — the web side of a shared community post.
 *
 * On a phone with Fazly installed this page is never reached: the association
 * files in `/.well-known` claim `/p/*` (SHARE_PATH_PATTERNS in packages/shared)
 * and the app opens the post itself. This is the fallback for everyone else.
 *
 * The path segment is the post's SHARE CODE — 72 random bits minted per post
 * (`shareCodeFromBytes`), never the row id — and this page does not resolve it.
 * A post can carry photographs of somebody's face and their score card, and a
 * public page that rendered them would lift both out of the community they
 * were posted into; `ShareLanding` says what was shared and how to open it, and
 * nothing else. `noindex` for the same reason.
 */
export const Route = createFileRoute("/p/$code")({
  headers: documentHeaders,
  head: () => shareLandingHead("post"),
  component: () => <ShareLanding kind="post" />,
});
